import { graphql, useStaticQuery } from "gatsby";

export function useImages(): Record<
  string,
  { sizes: Record<"xs" | "sm" | "md" | "lg" | "xl" | "xxl", { src: string }> }
> {
  return useStaticQuery(graphql`
    query {
      bg1: file(relativePath: { eq: "Zeichenfläche – 8.jpg" }) {
        sizes: childImageSharp {
          xs: resize(width: 576, quality: 50) {
            src
          }
          sm: resize(width: 768, quality: 60) {
            src
          }
          md: resize(width: 992, quality: 70) {
            src
          }
          lg: resize(width: 1200, quality: 80) {
            src
          }
          xl: resize(width: 1400, quality: 90) {
            src
          }
          xxl: resize(width: 2000, quality: 90) {
            src
          }
        }
      }

      bg2: file(relativePath: { eq: "Zeichenfläche – 12.jpg" }) {
        sizes: childImageSharp {
          xs: resize(width: 576) {
            src
          }
          sm: resize(width: 768) {
            src
          }
          md: resize(width: 992) {
            src
          }
          lg: resize(width: 1200) {
            src
          }
          xl: resize(width: 1400) {
            src
          }
          xxl: resize(width: 2000) {
            src
          }
        }
      }

      bg3: file(relativePath: { eq: "Zeichenfläche – 9.jpg" }) {
        sizes: childImageSharp {
          xs: resize(width: 576) {
            src
          }
          sm: resize(width: 768) {
            src
          }
          md: resize(width: 992) {
            src
          }
          lg: resize(width: 1200) {
            src
          }
          xl: resize(width: 1400) {
            src
          }
          xxl: resize(width: 2000) {
            src
          }
        }
      }

      bg4: file(relativePath: { eq: "Zeichenfläche – 11.jpg" }) {
        sizes: childImageSharp {
          xs: resize(width: 576) {
            src
          }
          sm: resize(width: 768) {
            src
          }
          md: resize(width: 992) {
            src
          }
          lg: resize(width: 1200) {
            src
          }
          xl: resize(width: 1400) {
            src
          }
          xxl: resize(width: 2000) {
            src
          }
        }
      }

      bg5: file(relativePath: { eq: "Zeichenfläche – 10.jpg" }) {
        sizes: childImageSharp {
          xs: resize(width: 576) {
            src
          }
          sm: resize(width: 768) {
            src
          }
          md: resize(width: 992) {
            src
          }
          lg: resize(width: 1200) {
            src
          }
          xl: resize(width: 1400) {
            src
          }
          xxl: resize(width: 2000) {
            src
          }
        }
      }

      bg6: file(relativePath: { eq: "Zeichenfläche – 6.jpg" }) {
        sizes: childImageSharp {
          xs: resize(width: 576) {
            src
          }
          sm: resize(width: 768) {
            src
          }
          md: resize(width: 992) {
            src
          }
          lg: resize(width: 1200) {
            src
          }
          xl: resize(width: 1400) {
            src
          }
          xxl: resize(width: 2000) {
            src
          }
        }
      }
    }
  `);
}
